import '@shui/core/sh-radio-button';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-radio-button',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.label]': 'label() ?? null',
        '[attr.active]': 'active() ? "" : null',
        '[attr.neutral]': 'neutral() ? "" : null',
        '[attr.readonly]': 'readonly() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null'
    }
})
export class ShRadioButtonComponent {
    /** Defines the label of the radio button. */
    public readonly label = input<string | number | undefined>(undefined);

    /** Defines if a radio button is checked or not. Changes when clicked. */
    public readonly active = input(false, { transform: booleanAttribute });

    /** If true, the active state will be gray instead of orange. */
    public readonly neutral = input(false, { transform: booleanAttribute });

    /**
     * If true, the radio button is non-interactive, but the label keeps its appearance and remains
     * fully readable.
     */
    public readonly readonly = input(false, { transform: booleanAttribute });

    /** Defines if a radio button is disabled. If true, it won't allow clicks. */
    public readonly disabled = input(false, { transform: booleanAttribute });
}
